customElements.define(
  "modal-toggle",
  class ModalToggle extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", () => {
        const { type } = this.dataset;
        if (type) {
          window.dispatchEvent(
            new CustomEvent("modal-toggle", {
              detail: { type },
            }),
          );
        }
      });
    }
  },
);
